module.exports = __webpack_public_path__ + "static/media/activity_select_icon.11ed354e.svg";